module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg28.bff4733d.jpg";